export function checkParent(parent, child) {
  let node = child;

  // keep iterating unless null
  while (node != null) {
      if (node == parent) {
          return true;
      }
   node = node.parentNode;
   }
 return false;
}
